import * as types from './actionTypes';

export function loadSite() {
    const { site } = window.appConfig;
    return (dispatch: any) => dispatch({ type: types.LOAD_SITE_CONSTANTS, site });
}
